import React, { useEffect, useState } from 'react';
import { getSharesWaste } from '../../apis/Business/WasteApi';
import { GoogleMap, useLoadScript, Marker, InfoWindow, InfoWindowF } from '@react-google-maps/api'; 
import EditableResult from '../../components/EditableResult';
import './index.css';

const containerStyle = {
  width: '100%',
  height: '90vh'
};

const center = {
  lat: 0,
  lng: 0
};

const WasteMap = () => {
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [markers, setMarkersData] = useState([])
  const [searchItem, setSearchItem] = useState("")

  useEffect(() => {
    getSharesWaste(setMarkersData, searchItem)
  }, [searchItem])

  if(!markers) return <div>Loading. . . .</div>

  return (
    <>
      <div className="search__field">
        <EditableResult
            result={searchItem}
            edit={true}
            changeTo={searchItem}
            setValue={setSearchItem}
            autosave={true}
            placeholder="Search waste item"
        />
      </div>
      <Map data={markers} selectedLocation={selectedLocation} setSelectedLocation={setSelectedLocation}/>
    </>
    
  )
}

const Map = ({data, selectedLocation, setSelectedLocation}) => {
  console.log(data)
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_PLACE_API,
  })

  if(!isLoaded) return <div>Loading. . . .</div>

  return (
    <div style={{marginTop: 50}}>
      <div style={{position:"absolute", marginRight: 30, padding:20, backgroundColor:"white", width:"300px", height:"700px", zIndex:100, cursor:"pointer", overflow:"auto"}}>
        {data.map(el => (
          <div style={{marginBottom: 20}} onClick={() => setSelectedLocation(el)}>
            <h6>Material: {el.content}</h6>
            <h6>Quantity: {el.amount}</h6>
            <h6>Company name: {el.name}</h6>
            <h6>Company address: {el.address}</h6>
            <h6>Company email: {el.email}</h6>
            <hr/>
          </div>
        ))
        }
      </div>
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={2}
      >
        <Markers data={data} selectedLocation={selectedLocation} setSelectedLocation={setSelectedLocation}/> 
      </GoogleMap>
    </div>
  );
}

const Markers = ({data, selectedLocation, setSelectedLocation}) => {
  return (
    data.map(el => (
      <Marker
        key={el.id}
        position={{lat: el.latitude, lng: el.longitude}}
        onClick={() => setSelectedLocation(el)}
      >
        {
          selectedLocation && selectedLocation.id === el.id ?
            <InfoWindowF position={{lat: el.latitude, lng: el.longitude}} onCloseClick={() => setSelectedLocation(null)}>
              <div>
                <h6>{el.name}</h6>
                <br/>
                <p>{el.address}</p>
                <p>{el.email}</p>
              </div>
            </InfoWindowF>
          : null
        }
      </Marker>
    ))
  )
}

export default WasteMap